import { EOrientation } from '@Managers/Device/UseWindowDimensions.types';
import { EGameStates } from '@Managers/StateManager/GameStates';
import {
    ACCOUNT_DEFAULTS,
    APP_STATE_DEFAULTS,
    AUTHENTICATE_GAME_CONFIG_DEFAULTS,
    AUTOPLAY_STATE_DEFAULTS,
    BASE_WIN_PRESENTATION_STATE_DEFAULTS,
    BEFORE_WIN_ANIMATION_CONFIGURATION_DEFAULTS,
    BET_STATE_DEFAULTS,
    BUTTON_STATE_DEFAULTS,
    DEBUG_WIN_PRESENTATION_MODE_STATE_DEFAULTS,
    ENVIRONMENT_CONFIGURATION_DEFAULTS,
    EXPANDING_SYMBOL_FEATURE_STATE_DEFAULTS,
    FEATURES_DEFAULT,
    FREE_GAMES_DEFAULTS,
    FREEGAMES_AUTOPLAY_STATE_DEFAULTS,
    GAMBLE_CONFIGURATION_DEFAULTS,
    GAMBLE_RESPONSE_DEFAULTS,
    GAMBLE_STATE_DEFAULTS,
    GAME_PLAY_MESSAGES_DEFAULTS,
    JACKPOT_CASINO_STATE_DEFAULTS,
    JACKPOT_WIN_CONFIGURATION_DEFAULTS,
    LOCK_AND_ROLL_DEFAULTS,
    ORIGINAL_SPIN_RESPONSE_DEFAULTS,
    PRELOADER_CONFIGURATION_DEFAULTS,
    REEL_PARAMETERS_DEFAULTS,
    SOUND_CONFIGURATION_DEFAULTS,
    SOUND_SETTINGS_DEFAULTS,
    SPIN_OUTCOME_DEFAULTS,
    SPIN_PARAMETERS_DEFAULTS,
    SPIN_PARAMETERS_SETS_DEFAULTS,
    SYMBOL_CONFIGURATION_DEFAULTS,
    SYMBOL_PARAMETERS_DEFAULTS,
    TEXT_VARIABLES_DEFAULTS,
    TURBO_MODE_STATE_DEFAULTS,
    WILD_WHEEL_CONFIGURATION_DEFAULTS,
    WIN_CONFIGURATION_DEFAULTS,
    WIN_LEVELS_CONFIGURATION_DEFAULTS,
    WIN_PRESENTATION_DEFAULTS,
    WINTAB_CONFIGURATION_DEFAULT
} from './Defaults';
import { EGameStoreKeys, IGameStoreSchema } from './GameStoreSchema';

export const GAME_STORE_DEFAULTS: IGameStoreSchema = {
    [EGameStoreKeys.GeneralAppState]: APP_STATE_DEFAULTS,
    [EGameStoreKeys.CurrentGameState]: EGameStates.IDLE_STATE,
    [EGameStoreKeys.CurrentGameSubState]: undefined,
    [EGameStoreKeys.PreloaderState]: {},
    [EGameStoreKeys.CurrentOrientation]: EOrientation.LANDSCAPE,
    [EGameStoreKeys.IsMobile]: false,
    [EGameStoreKeys.IsFullscreen]: false,
    [EGameStoreKeys.DevicePixelRatio]: window.devicePixelRatio,
    [EGameStoreKeys.GameVirtualSize]: { x: 1920, y: 1080 },
    [EGameStoreKeys.UIMaxScreenCoverage]: 0.5,
    [EGameStoreKeys.NumberOfReels]: 3,
    [EGameStoreKeys.NumberOfSymbolsPerReel]: 3,
    [EGameStoreKeys.NumberOfSpinningSpines]: 25,
    [EGameStoreKeys.GameType]: 1,
    [EGameStoreKeys.IsTakeInitiated]: false,
    [EGameStoreKeys.IsTakeCompleted]: true,
    [EGameStoreKeys.SymbolParameters]: SYMBOL_PARAMETERS_DEFAULTS,
    [EGameStoreKeys.ReelParameters]: REEL_PARAMETERS_DEFAULTS,
    [EGameStoreKeys.SpinParametersSets]: SPIN_PARAMETERS_SETS_DEFAULTS,
    [EGameStoreKeys.SpinParameters]: SPIN_PARAMETERS_DEFAULTS,
    [EGameStoreKeys.VisibleSymbols]: [],
    [EGameStoreKeys.OriginalSpinResponse]: ORIGINAL_SPIN_RESPONSE_DEFAULTS,
    [EGameStoreKeys.SpinOutcome]: SPIN_OUTCOME_DEFAULTS,
    [EGameStoreKeys.ResumedSpinOutcome]: undefined,
    [EGameStoreKeys.GambleResponse]: GAMBLE_RESPONSE_DEFAULTS,
    [EGameStoreKeys.ButtonState]: BUTTON_STATE_DEFAULTS,
    [EGameStoreKeys.AutoPlayState]: AUTOPLAY_STATE_DEFAULTS,
    [EGameStoreKeys.FreeGamesAutoPlayState]: FREEGAMES_AUTOPLAY_STATE_DEFAULTS,
    [EGameStoreKeys.TurboModeState]: TURBO_MODE_STATE_DEFAULTS,
    [EGameStoreKeys.BetState]: BET_STATE_DEFAULTS,
    [EGameStoreKeys.SoundSettings]: SOUND_SETTINGS_DEFAULTS,
    [EGameStoreKeys.SymbolConfiguration]: SYMBOL_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.EnvironmentConfiguration]: ENVIRONMENT_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.WintabConfiguration]: WINTAB_CONFIGURATION_DEFAULT,
    [EGameStoreKeys.SoundsConfiguration]: SOUND_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.PreloaderConfiguration]: PRELOADER_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.WildWheelConfiguration]: WILD_WHEEL_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.WinLevelsConfiguration]: WIN_LEVELS_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.JackpotWinConfiguration]: JACKPOT_WIN_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.WinConfiguration]: WIN_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.WaysConfiguration]: {},
    [EGameStoreKeys.LocalStorageConfiguration]: {},
    [EGameStoreKeys.GamePlayMessages]: GAME_PLAY_MESSAGES_DEFAULTS,
    [EGameStoreKeys.GambleConfiguration]: GAMBLE_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.GambleState]: GAMBLE_STATE_DEFAULTS,
    [EGameStoreKeys.Account]: ACCOUNT_DEFAULTS,
    [EGameStoreKeys.AuthenticateGameConfig]: AUTHENTICATE_GAME_CONFIG_DEFAULTS,
    [EGameStoreKeys.AuthenticateStartSymbols]: [],
    [EGameStoreKeys.StartHistorySymbols]: [],
    [EGameStoreKeys.WinPresentation]: WIN_PRESENTATION_DEFAULTS,
    [EGameStoreKeys.TransactionCycleStarted]: false,
    [EGameStoreKeys.HighestSymbolCountOnPayLine]: 0,
    [EGameStoreKeys.IsQuickStopInitiated]: false,
    [EGameStoreKeys.IsUIBlocked]: false,
    [EGameStoreKeys.IsPauseInitiated]: false,
    [EGameStoreKeys.ExpandingSymbolState]: EXPANDING_SYMBOL_FEATURE_STATE_DEFAULTS,
    [EGameStoreKeys.Features]: FEATURES_DEFAULT,
    [EGameStoreKeys.IsFreeGamesMode]: false,
    [EGameStoreKeys.IsFreeGamesIntro]: false,
    [EGameStoreKeys.IsFreeGamesOutro]: false,
    [EGameStoreKeys.IsLockAndRollMode]: false,
    [EGameStoreKeys.FreeGames]: FREE_GAMES_DEFAULTS,
    [EGameStoreKeys.LockAndRoll]: LOCK_AND_ROLL_DEFAULTS,
    [EGameStoreKeys.LastSpinBet]: 0,
    [EGameStoreKeys.BeforeWinAnimationConfiguration]: BEFORE_WIN_ANIMATION_CONFIGURATION_DEFAULTS,
    [EGameStoreKeys.BaseWinPresentationState]: BASE_WIN_PRESENTATION_STATE_DEFAULTS,
    [EGameStoreKeys.GameHistoryState]: {
        actionsCollection: [],
        spinsHistory: [],
        spinNr: 0,
        isHistoryMode: false
    },
    [EGameStoreKeys.BonusBuy]: {
        isBonusBuyRound: false,
        isDialogOpen: false,
        bonusBuyBet: 0,
        bonusOption: 1,
        bonusBuyInitData: {
            bonusbuy_spin: {
                default: 0,
                steps: []
            }
        },
        bonusBuyConfig: {
            id: 0,
            multiplicator: 0
        }
    },
    [EGameStoreKeys.DebugWinPresentationModeState]: DEBUG_WIN_PRESENTATION_MODE_STATE_DEFAULTS,
    [EGameStoreKeys.TextVariables]: TEXT_VARIABLES_DEFAULTS,
    [EGameStoreKeys.IsGameRestored]: false,
    [EGameStoreKeys.CurrentSpecialGamesType]: undefined,
    [EGameStoreKeys.NextActions]: [],
    [EGameStoreKeys.Collectors]: undefined,
    [EGameStoreKeys.JackpotCasinoState]: JACKPOT_CASINO_STATE_DEFAULTS
};
